/**
 * Dashboard Grid Component
 * react-grid-layout を使用したドラッグ&ドロップ可能なグリッドレイアウト
 */

import { ReactNode, useRef, useEffect, useState } from 'react';
import GridLayout from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { Box } from '@mantine/core';
import type { Layout } from 'react-grid-layout';

type DashboardGridProps = {
  layout: Layout[];
  onLayoutChange: (layout: Layout[]) => void;
  isEditMode: boolean;
  children: ReactNode;
};

export const DashboardGrid = ({ layout, onLayoutChange, isEditMode, children }: DashboardGridProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState(1200);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  return (
    <Box ref={containerRef} style={{ position: 'relative', width: '100%' }}>
      <GridLayout
        className={`dashboard-grid-layout ${isEditMode ? 'edit-mode' : ''}`}
        layout={layout}
        cols={12}
        rowHeight={30}
        width={containerWidth}
        onLayoutChange={onLayoutChange}
        isDraggable={isEditMode}
        isResizable={isEditMode}
        resizeHandles={['se']}
        margin={[12, 12]}
        containerPadding={[0, 0]}
        compactType={null}
        useCSSTransforms={true}
      >
        {children}
      </GridLayout>
    </Box>
  );
};
